import type { ReactNode } from "react";
import { Wordmark } from "./wordmark";

/**
 * The console's brand row: the wordmark at the height, size and inset the
 * console's sidebar opens with. One piece, so the sign-in and onboarding
 * screens wear exactly the console's brand rather than a copy of it (owner,
 * 2026-09-25; wave 88).
 *
 * `lead` is what stands before the wordmark (the console's small doorman);
 * `end` is what stands at the far right (a poster's About link).
 *
 * `compact` is the posters' size (owner, after seeing it, 2026-09-25): 44px
 * rather than 56, the wordmark scaled with it (17px rather than 22). The
 * console keeps the full size. The `!` is needed because the wordmark's own
 * 22px class is the one that otherwise wins.
 */
export function BrandBar({
  lead,
  end,
  compact = false,
}: {
  lead?: ReactNode;
  end?: ReactNode;
  compact?: boolean;
}) {
  return (
    <div className={`flex ${compact ? "h-11" : "h-14"} shrink-0 items-center gap-2 px-4`}>
      {lead}
      <Wordmark className={compact ? "h-[17px]!" : "h-5"} />
      {end && <div className="ml-auto">{end}</div>}
    </div>
  );
}
